<shared-list-for-loyalty-free-products [placeholders]="1" [loading]="loading$ | async"
    class="loyalty-for-member-free-products" [programProducts]="freeProducts$ | async">
</shared-list-for-loyalty-free-products>